import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const solutions = ['Personalized consultation before every cut', 'Certified technicians in modern and classic styles', 'Premium unisex environment without judgment', 'Results that speak for themselves'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: 20
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function SolutionSection() {
  return <section className="py-24 px-4 bg-matte relative overflow-hidden" data-id="element-112">
      {/* Subtle background glow */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-96 h-96 bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-113"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-114">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="font-display text-3xl md:text-4xl text-gold text-center mb-16 italic" data-id="element-115">
          Axel Cut & Style Studio is different because...
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-6" data-id="element-116">
          {solutions.map((solution, index) => <motion.div key={index} variants={itemVariants} className="flex items-center gap-4 bg-dark p-6 rounded-lg border border-gold/10 hover:border-gold/30 transition-colors duration-300" data-id="element-117">
              <CheckCircleIcon className="w-6 h-6 text-gold flex-shrink-0" data-id="element-118" />
              <p className="font-body text-white text-lg md:text-xl font-light" data-id="element-119">
                {solution}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}